module.exports = __webpack_public_path__ + "5a4e7b10aa4005a8bcda02519871760e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/fontello/fontello.svg?67495670
// module id = 8041
// module chunks = 0